import React from 'react';

import type { Control, Path, FieldValues } from 'react-hook-form';

import { ControllableValueSelect } from '@vlabs/monokit/shared/ui/value-select';

import { DiagramTypes } from '../constants';
import { i18nChartFormTranslation } from '../i18n';

export const diagramTypeOptions = [
  {
    get label(): string {
      return i18nChartFormTranslation('options.diagram_type.bar');
    },
    value: DiagramTypes.BAR,
  },
  {
    get label(): string {
      return i18nChartFormTranslation('options.diagram_type.horizontal_bar');
    },
    value: DiagramTypes.HORIZONTAL_BAR,
  },
  {
    get label(): string {
      return i18nChartFormTranslation('options.diagram_type.area');
    },
    value: DiagramTypes.AREA,
  },
  {
    get label(): string {
      return i18nChartFormTranslation('options.diagram_type.step_area');
    },
    value: DiagramTypes.STEP_AREA,
  },
  {
    get label(): string {
      return i18nChartFormTranslation('options.diagram_type.stack');
    },
    value: DiagramTypes.STACK,
  },
  {
    get label(): string {
      return i18nChartFormTranslation('options.diagram_type.line');
    },
    value: DiagramTypes.LINE,
  },
  {
    get label(): string {
      return i18nChartFormTranslation('options.diagram_type.pie');
    },
    value: DiagramTypes.PIE,
  },
  {
    get label(): string {
      return i18nChartFormTranslation('options.diagram_type.doughnut');
    },
    value: DiagramTypes.DOUGHNUT,
  },
  {
    get label(): string {
      return i18nChartFormTranslation('options.diagram_type.radar');
    },
    value: DiagramTypes.RADAR,
  },
];

interface DiagramTypeSelectProps<TFieldValues extends FieldValues = FieldValues> {
  control: Control<TFieldValues>;
  name: Path<TFieldValues>;
}

export function DiagramTypeSelect({
  control,
  name,
}: DiagramTypeSelectProps): React.JSX.Element {
  return (
    <ControllableValueSelect
      control={control}
      id={name}
      name={name}
      options={diagramTypeOptions}
    />
  );
}
